import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { ServiceAppointmentState } from '../../../../../store/service-appointment/service-appointment.reducer';
import { Store } from '@ngrx/store';
import * as fromServiceSelectors from '../../../../../store/service-appointment/service-appointment.selectors';
import * as fromSalesSelectors from '../../../../../store/sales-appointment/sales-appointment.selectors';
import * as fromPartsSelectors from '../../../../../store/parts-appointment/parts-appointment.selectors';
import { Observable, Subscription } from 'rxjs';
import { AppointmentType, IAvailability, IAvailabilityOptions, ITransportOption, IVehicle } from '@signal/asp-data-commons';
import { LoadAvailability } from '../../../../../store/service-appointment/service-appointment.actions';
import * as fromActions from '../../../../../store/sales-appointment/sales-appointment.actions';
import * as fromPartsActions from '../../../../../store/parts-appointment/parts-appointment.actions';
import {  debounceTime, take, takeLast } from 'rxjs/operators';
import { DateTime } from 'luxon';
import { SalesAppointmentState } from '../../../../../store/sales-appointment/sales-appointment.reducer';
import { PartsAppointmentState } from '../../../../../store/parts-appointment/parts-appointment.reducer';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../../../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../../../../shared/services/util.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-appointment-time-dashboard',
  templateUrl: './appointment-time.component.html',
  styleUrls: ['./appointment-time.component.scss']
})
export class AppointmentTimeComponent implements OnInit, OnDestroy {
  @Input() transport;
  @Input() stepIndex = 2;
  @Input() apptType = AppointmentType.SERVICE;
  @Input() apptId = null;
  @Input() vehicle?: IVehicle = null;
  @Input() checklistDuration?:  { min: number; };
  @Output() availabilityChange = new EventEmitter();
  @Input() data;
  step: UntypedFormGroup;
  private availability: UntypedFormControl;
  availabilityOptions$: Observable<IAvailabilityOptions>;
  availabilityOptionsLoading$: Observable<boolean>;
  availability$: Observable<IAvailability>;
  availabilityLoading$: Observable<boolean>;
  private subs : SubscriptionList = {};
  prevCheckData;
  firstTime: boolean = true;
  dateFormat : string = 'yyyy-MM-dd';
  languageId='';
  apptAdvisor = '';

  constructor(
              private readonly formBuilder: UntypedFormBuilder,
              private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
              private readonly salesAppointmentState:Store<SalesAppointmentState>,
    private readonly partsAppointmentState: Store<PartsAppointmentState>,
              private readonly translate: TranslateService) {
  }

  ngOnInit(): void {
    this.ready();
    this.initialiseSubs();
  }

  ready() {
    this.step = this.formBuilder.group({
      availability: this.availability,
      timeSlotValidator:[false, Validators.required]
    });
    if(this.apptType === AppointmentType.SERVICE){
      this.availabilityOptions$ = this.serviceAppointmentState.select(fromServiceSelectors.selectAvailabilityOptionsData);
      this.availabilityOptionsLoading$ = this.serviceAppointmentState.select(fromServiceSelectors.selectAvailabilityOptionsLoading);
      this.availability$ = this.serviceAppointmentState.select(fromServiceSelectors.selectAvailabilityData);
      this.availabilityLoading$ = this.serviceAppointmentState.select(fromServiceSelectors.selectAvailabilityLoading);
      this.subs.form=this.serviceAppointmentState.select(fromServiceSelectors.stateDetails).subscribe(data => {
          this.languageId = data?.appointmentForm?.availabilityForm?.availability?.languageId;
          this.apptAdvisor = data?.appointmentForm?.availabilityForm?.availability?.advisorId;
      });
    }
    else if(this.apptType === AppointmentType.TEST_DRIVE || this.apptType === AppointmentType.DELIVERY || this.apptType === AppointmentType.LEARNING || this.apptType === AppointmentType.VEHICLE_INQUIRY){
      this.availabilityOptions$ = this.salesAppointmentState.select(fromSalesSelectors.getAvailabilityOptions);
      this.availabilityOptionsLoading$ = this.salesAppointmentState.select(fromSalesSelectors.getAvailabilityOptionsLoading);
      this.availability$ = this.salesAppointmentState.select(fromSalesSelectors.getAvailability);
      this.availabilityLoading$ = this.salesAppointmentState.select(fromSalesSelectors.getAvailabilityLoading);
      this.subs.state = this.salesAppointmentState.select(fromSalesSelectors.stateDetails).subscribe(value=>{
      this.languageId=value?.appointment?.availability?.languageId;
      this.apptAdvisor = value?.appointment?.availability?.advisorId;

        if(value && value.appointment.availability.appointmentStartDate.length > 0 
          && value.availability.loaded 
          && (DateTime.fromFormat(value.availability.data.dayStartAt, this.dateFormat).startOf('month').month === DateTime.fromFormat(value.appointment.availability.appointmentStartDate, this.dateFormat).startOf('month').month ))  {
            if(_.isEqual(this.prevCheckData, value.appointment.availability)) {
              return;  
            }
        const payloadAvailability = value.appointment.availability;
        this.prevCheckData = value.appointment.availability;
          if(this.firstTime) {
            this.firstTime = false;
            this.step.patchValue({
                availability : payloadAvailability
              });
          }
        }
      })
    }
    else if (this.apptType === AppointmentType.PARTS) {
      this.availabilityOptions$ = this.partsAppointmentState.select(fromPartsSelectors.getAvailabilityOptions);
      this.availabilityOptionsLoading$ = this.partsAppointmentState.select(fromPartsSelectors.getAvailabilityOptionsLoading);
      this.availability$ = this.partsAppointmentState.select(fromPartsSelectors.getAvailability);
      this.availabilityLoading$ = this.partsAppointmentState.select(fromPartsSelectors.getAvailabilityLoading);
      this.subs.partsState = this.partsAppointmentState.select(fromPartsSelectors.stateDetails).subscribe(value => {
        this.languageId = value?.appointment?.availability?.languageId;
        this.apptAdvisor = value?.appointment?.availability?.advisorId;

        if (value && value.appointment.availability.appointmentStartDate.length > 0
          && value.availability.loaded
          && (DateTime.fromFormat(value.availability.data.dayStartAt, this.dateFormat).startOf('month').month === DateTime.fromFormat(value.appointment.availability.appointmentStartDate, this.dateFormat).startOf('month').month)) {
          if (_.isEqual(this.prevCheckData, value.appointment.availability)) {
            return;
          }
          const payloadAvailability = value.appointment.availability;
          this.prevCheckData = value.appointment.availability;
          if (this.firstTime) {
            this.firstTime = false;
            this.step.patchValue({
              availability: payloadAvailability
            });
          }
        }
      })
    }
    
  }

  initialiseSubs(){
    if (this.apptType === AppointmentType.TEST_DRIVE || this.apptType === AppointmentType.DELIVERY || this.apptType === AppointmentType.LEARNING || this.apptType === AppointmentType.VEHICLE_INQUIRY || this.apptType === AppointmentType.PARTS) {
      this.subs.stepChange = this.step.valueChanges.subscribe(value=>{
        this.availabilityChange.emit(value.availability);
      })
    }
    
  }

  onMonthChange($event: DateTime) {
    if(this.apptType === AppointmentType.SERVICE){
      this.subs.advisorId = this.serviceAppointmentState.select(fromServiceSelectors.selectAvailabilityFormAdvisorId)
      .pipe(take(1))
      .subscribe((advisorId: string) => {
       const date = $event.toFormat(this.dateFormat);
       const vin = this.vehicle.vin || '';
        this.serviceAppointmentState.dispatch(new LoadAvailability({date, advisorId, transport:this.transport, vin: vin, appointmentId:this.apptId}));
      });
    } /* *availability loads differently for testdrive appts, vehicles with a vin or without a vin */ 
    else if (this.apptType === AppointmentType.TEST_DRIVE && this.vehicle?.vin) {
      this.subs.getAvailabilityFormAdvisorId = this.salesAppointmentState.select(fromSalesSelectors.getAvailabilityFormAdvisorId)
      .pipe(take(1))
      .subscribe((advisorId: string) => {
       const date = $event.toFormat(this.dateFormat);
        this.salesAppointmentState.dispatch(new fromActions.LoadAvailability({selectDateAndSlot: true, date, advisorId, transport:this.transport, vin: this.vehicle.vin, appointmentType: AppointmentType.TEST_DRIVE,appointmentId:this.apptId}));
      });
    } else if (this.apptType === AppointmentType.TEST_DRIVE || this.apptType === AppointmentType.DELIVERY || this.apptType === AppointmentType.LEARNING || this.apptType === AppointmentType.VEHICLE_INQUIRY) {
      this.subs.salesAdvisor = this.salesAppointmentState.select(fromSalesSelectors.getAvailabilityDetails)
      .pipe(take(1))
      .subscribe((availabilityDetails: any) => {
       const date = $event.toFormat(this.dateFormat);
       const payload = {selectDateAndSlot: true, date, advisorId: availabilityDetails.advisorId, fniAdvisorId: availabilityDetails.fniAdvisorId || '-1', transport:this.transport , appointmentType: this.apptType,appointmentId:this.apptId};
        this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(payload));
      });
    } else if (this.apptType === AppointmentType.PARTS) {
      this.subs.partsAdvisor = this.partsAppointmentState.select(fromPartsSelectors.getAvailabilityFormAdvisorId)
        .pipe(take(1))
        .subscribe((advisorId: string) => {
          const date = $event.toFormat(this.dateFormat);
          const payload = { selectDateAndSlot: true, date, advisorId, transport: this.transport, appointmentType: this.apptType, appointmentId: this.apptId };
          this.partsAppointmentState.dispatch(new fromPartsActions.LoadAvailability(payload));
        });
    }

  }
  setValidatorsForTimeSlot(event){
    if(event){
      this.step.controls.timeSlotValidator.setErrors({ error: this.translate.instant('service.invalidTimeslot') });
      this.step.controls.timeSlotValidator.setValidators(Validators.required);
    }else{
      this.step.controls.timeSlotValidator.clearValidators();
      this.step.controls.timeSlotValidator.updateValueAndValidity();
    }
   }

   ngOnDestroy(){
     unsubscribeSubscriptions(this.subs);
   }
}
